import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fixed top-0 left-0 z-10 h-screen w-screen bg-nucleus-lightestBlue overflow-auto" }
const _hoisted_2 = { key: 4 }
const _hoisted_3 = { class: "px-4" }
const _hoisted_4 = { class: "my-4" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "font-bold capitalize text-nucleus-primaryBlue" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "bg-nucleus-white" }
const _hoisted_12 = { class: "flex items-center px-4 py-6 border-b" }
const _hoisted_13 = { class: "text-2xl" }
const _hoisted_14 = { class: "px-4 pt-6" }
const _hoisted_15 = {
  key: 0,
  class: "p-4"
}
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = {
  key: 0,
  class: "text-center"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 5,
  class: "overflow-auto h-screen w-screen fixed top-0 left-0 bg-white"
}
const _hoisted_20 = { class: "bg-nucleus-white" }
const _hoisted_21 = { class: "flex items-center px-4 py-6 border-b" }
const _hoisted_22 = { class: "text-2xl" }
const _hoisted_23 = { class: "px-4 pt-6" }
const _hoisted_24 = {
  key: 3,
  class: "cursor-pointer text-nucleus-primaryBlue underline mb-6"
}
const _hoisted_25 = {
  key: 4,
  class: "cursor-pointer text-nucleus-error underline text-sm"
}
const _hoisted_26 = {
  key: 6,
  class: "overflow-auto h-screen w-screen fixed top-0 left-0 bg-white p-4"
}
const _hoisted_27 = { class: "flex items-center justify-between mb-4" }
const _hoisted_28 = { class: "text-2xl" }
const _hoisted_29 = { class: "pt-4 px-4" }
const _hoisted_30 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!
  const _component_ErrorBox = _resolveComponent("ErrorBox")!
  const _component_ModalDeleteCheck = _resolveComponent("ModalDeleteCheck")!
  const _component_ModalConfirmation = _resolveComponent("ModalConfirmation")!
  const _component_HeaderMini = _resolveComponent("HeaderMini")!
  const _component_HeaderShadow = _resolveComponent("HeaderShadow")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ButtonRed = _resolveComponent("ButtonRed")!
  const _component_InfoItem = _resolveComponent("InfoItem")!
  const _component_ListItemBasic = _resolveComponent("ListItemBasic")!
  const _component_AddButtonBasic = _resolveComponent("AddButtonBasic")!
  const _component_HeaderMiniBasic = _resolveComponent("HeaderMiniBasic")!
  const _component_Input = _resolveComponent("Input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LoadingScreen, {
      loaded: _ctx.loaded,
      message: _ctx.loadingMessage
    }, null, 8, ["loaded", "message"]),
    (_ctx.errorHeading || _ctx.errorContent)
      ? (_openBlock(), _createBlock(_component_ErrorBox, {
          key: 0,
          heading: _ctx.errorHeading,
          content: _ctx.errorContent,
          fixed: _ctx.errorFixed,
          onCloseError: _cache[0] || (_cache[0] = ($event: any) => {
        _ctx.errorHeading = '';
        _ctx.errorContent = '';
      })
        }, null, 8, ["heading", "content", "fixed"]))
      : _createCommentVNode("", true),
    (_ctx.warningHeading || _ctx.warningContent)
      ? (_openBlock(), _createBlock(_component_ErrorBox, {
          key: 1,
          heading: _ctx.warningHeading,
          content: _ctx.warningContent,
          fixed: true,
          warning: true,
          onCloseError: _cache[1] || (_cache[1] = ($event: any) => {
        _ctx.warningHeading = '';
        _ctx.warningContent = '';
      })
        }, null, 8, ["heading", "content"]))
      : _createCommentVNode("", true),
    (_ctx.deleteCheck)
      ? (_openBlock(), _createBlock(_component_ModalDeleteCheck, {
          key: 2,
          text: _ctx.$t('global.defaults.session', 1),
          onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteCheck = false)),
          onDeleteMe: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteSession()))
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_ctx.deleteCheckUser)
      ? (_openBlock(), _createBlock(_component_ModalConfirmation, {
          key: 3,
          text: _ctx.$t('pages.session.removeParticipant'),
          onYes: _cache[4] || (_cache[4] = ($event: any) => {
        _ctx.removeParticipant(_ctx.selectedParticipant);
        _ctx.deleteCheckUser = false;
      }),
          onNo: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteCheckUser = false))
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_HeaderMini, {
            name: _ctx.$t('global.defaults.session', 2),
            to: { name: 'sessions' },
            "can-delete": true,
            "can-edit": _ctx.session.state !== 'FINISHED',
            "no-menu": _ctx.session.state === 'STARTED',
            text: _ctx.$t('global.defaults.session', 1),
            onDeleteCheck: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteCheck = true)),
            onEdit: _cache[7] || (_cache[7] = ($event: any) => (_ctx.edit()))
          }, null, 8, ["name", "can-edit", "no-menu", "text"]),
          _createVNode(_component_HeaderShadow),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.session.state === 'PENDING' || _ctx.session.state === 'STARTING')
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "mt-4",
                  name: _ctx.$t('global.defaults.startSession'),
                  type: "button",
                  loading: _ctx.startingStopping,
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.startSession()))
                }, null, 8, ["name", "loading"]))
              : _createCommentVNode("", true),
            (_ctx.session.state === 'STARTED')
              ? (_openBlock(), _createBlock(_component_ButtonRed, {
                  key: 1,
                  class: "mt-4",
                  type: "button",
                  name: _ctx.$t('global.defaults.endSession'),
                  loading: _ctx.startingStopping,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.endSession()))
                }, null, 8, ["name", "loading"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.$t("global.defaults.status")) + " ", 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.mapState(_ctx.session.state)), 1)
              ]),
              (_ctx.session.state === 'PENDING' || _ctx.session.state === 'FAILED')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "bg-nucleus-white p-2 text-nucleus-primaryBlue w-full",
                    innerHTML: _ctx.$t('pages.session.pendingMessage')
                  }, null, 8, _hoisted_7))
                : _createCommentVNode("", true),
              (_ctx.session.state === 'FINISHED')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "bg-nucleus-white p-2 text-nucleus-primaryBlue w-full",
                    innerHTML: _ctx.$t('pages.session.finishedMessage')
                  }, null, 8, _hoisted_8))
                : _createCommentVNode("", true),
              (_ctx.session.state === 'STARTING')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "bg-nucleus-white p-2 text-nucleus-primaryBlue w-full",
                    innerHTML: _ctx.$t('pages.session.startingMessage')
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true),
              (_ctx.session.state === 'STARTED')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: "bg-nucleus-white p-2 text-nucleus-primaryBlue",
                    innerHTML: _ctx.$t('pages.session.startedMessage')
                  }, null, 8, _hoisted_10))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", {
                class: _normalizeClass(["text-3xl leading-none p-2 mr-6 flex self-center transition rounded-full icon-session", _ctx.getIconColour()])
              }, null, 2),
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.session.name), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_InfoItem, {
                heading: _ctx.$t('global.defaults.status'),
                value: _ctx.mapState(_ctx.session.state),
                class: "capitalize"
              }, null, 8, ["heading", "value"]),
              _createVNode(_component_InfoItem, {
                heading: _ctx.$t('global.defaults.headingName'),
                value: _ctx.session.name
              }, null, 8, ["heading", "value"]),
              _createVNode(_component_InfoItem, {
                heading: _ctx.$t('inputs.room.label'),
                value: _ctx.session.roomName
              }, null, 8, ["heading", "value"]),
              (_ctx.session.department)
                ? (_openBlock(), _createBlock(_component_InfoItem, {
                    key: 0,
                    heading: _ctx.$t('global.defaults.headingDepartment'),
                    value: _ctx.session.department
                  }, null, 8, ["heading", "value"]))
                : _createCommentVNode("", true),
              (_ctx.session.notes)
                ? (_openBlock(), _createBlock(_component_InfoItem, {
                    key: 1,
                    heading: _ctx.$t('global.defaults.headingNotes'),
                    value: _ctx.session.notes
                  }, null, 8, ["heading", "value"]))
                : _createCommentVNode("", true),
              (_ctx.session.createdOn)
                ? (_openBlock(), _createBlock(_component_InfoItem, {
                    key: 2,
                    heading: _ctx.$t('global.defaults.headingDateCreated'),
                    value: _ctx.getDate(_ctx.session.createdOn)
                  }, null, 8, ["heading", "value"]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.session.invitees)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("pages.session.selectedParticipants")) + " (" + _toDisplayString(_ctx.session.invitees.length) + "/" + _toDisplayString(_ctx.sessionOptions.maxRemoteUsers) + ") ", 1),
                (_ctx.session.invitees.length < 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.$t("pages.session.noParticipants")), 1))
                  : _createCommentVNode("", true),
                (_ctx.session.invitees.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderByName(_ctx.session.invitees), (user, index) => {
                        return (_openBlock(), _createBlock(_component_ListItemBasic, {
                          key: user.userId,
                          icon: "remote-user",
                          name: user.name,
                          status: user.userStatus,
                          notes: _ctx.getParticipantNotes(user),
                          class: "cursor-pointer",
                          onClick: ($event: any) => (_ctx.getParticipantDetails(index))
                        }, null, 8, ["name", "status", "notes", "onClick"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (
            _ctx.session.state !== 'FINISHED' &&
            _ctx.session.invitees.length < _ctx.sessionOptions.maxRemoteUsers
          )
                  ? (_openBlock(), _createBlock(_component_AddButtonBasic, {
                      key: 2,
                      class: "mt-4",
                      name: _ctx.$t('buttons.addParticipant'),
                      icon: true,
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toggleParticipants()))
                    }, null, 8, ["name"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showParticipantDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_HeaderMiniBasic, {
            name: _ctx.selectedParticipant.name,
            onGoBack: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showParticipantDetails = false))
          }, null, 8, ["name"]),
          _createVNode(_component_HeaderShadow),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "text-3xl leading-none p-2 mr-6 flex self-center transition bg-nucleus-primaryBlue text-nucleus-white rounded-full icon-remote-user" }, null, -1)),
              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("pages.session.participantDetails")), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_InfoItem, {
                heading: _ctx.$t('global.defaults.headingAccountStatus'),
                value: _ctx.mapState(_ctx.selectedParticipant.userStatus)
              }, null, 8, ["heading", "value"]),
              (_ctx.getParticipantNotes(_ctx.selectedParticipant))
                ? (_openBlock(), _createBlock(_component_InfoItem, {
                    key: 0,
                    heading: _ctx.$t('global.defaults.headingSessionState'),
                    value: _ctx.getParticipantNotes(_ctx.selectedParticipant)
                  }, null, 8, ["heading", "value"]))
                : _createCommentVNode("", true),
              _createVNode(_component_InfoItem, {
                heading: _ctx.$t('global.defaults.headingName'),
                value: _ctx.selectedParticipant.name
              }, null, 8, ["heading", "value"]),
              _createVNode(_component_InfoItem, {
                heading: _ctx.$t('global.defaults.headingEmail'),
                value: _ctx.selectedParticipant.email
              }, null, 8, ["heading", "value"]),
              _createVNode(_component_InfoItem, {
                heading: _ctx.$t('global.defaults.headingMobilePhone'),
                value: _ctx.selectedParticipant.phone
              }, null, 8, ["heading", "value"]),
              (_ctx.selectedParticipant.affiliation)
                ? (_openBlock(), _createBlock(_component_InfoItem, {
                    key: 1,
                    heading: _ctx.$t('global.defaults.headingAffiliation'),
                    value: _ctx.selectedParticipant.affiliation
                  }, null, 8, ["heading", "value"]))
                : _createCommentVNode("", true),
              (_ctx.selectedParticipant.notes)
                ? (_openBlock(), _createBlock(_component_InfoItem, {
                    key: 2,
                    heading: _ctx.$t('global.defaults.headingNotes'),
                    value: _ctx.selectedParticipant.notes
                  }, null, 8, ["heading", "value"]))
                : _createCommentVNode("", true),
              (_ctx.session.state === 'STARTED' || _ctx.session.state === 'STARTING')
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("span", {
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.reinviteParticipant(_ctx.selectedParticipant)))
                    }, _toDisplayString(_ctx.$t("pages.session.reInvite")), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.session.state !== 'FINISHED')
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("span", {
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.deleteCheckUser = true))
                    }, _toDisplayString(_ctx.$t("pages.session.removeParticipantHeading")), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showParticipants)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("buttons.addParticipant")), 1),
            _createElementVNode("div", {
              class: "text-3xl p-2 bg-nucleus-lightGreyMouseOver hover:bg-nucleus-primaryBlue hover:text-nucleus-white transition leading-none flex self-center cursor-pointer icon-close rounded-full",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.toggleParticipants()))
            })
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_Input, {
              id: "filter",
              value: _ctx.nameFilter,
              "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.nameFilter) = $event)),
              "input-type": "text",
              label: _ctx.$t('inputs.filter.label'),
              class: "custom-bg",
              "max-length": _ctx.inputMaxLengths.name,
              filter: true,
              placeholder: _ctx.$t('inputs.filter.placeholder'),
              onInput: _cache[16] || (_cache[16] = ($event: any) => (_ctx.filterByName(_ctx.nameFilter))),
              onClearInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.clearInput()))
            }, null, 8, ["value", "label", "max-length", "placeholder"])
          ]),
          (_ctx.users)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                  return (_openBlock(), _createBlock(_component_ListItemBasic, {
                    key: user.userId,
                    icon: "remote-user",
                    name: user.name,
                    status: user.status,
                    "invite-state": user.state,
                    "invite-reason": user.reason,
                    class: _normalizeClass(["cursor-pointer", {
            'opacity-50 cursor-not-allowed': user.status !== 'VERIFIED',
          }]),
                    onClick: ($event: any) => (_ctx.addParticipant(user))
                  }, null, 8, ["name", "status", "invite-state", "invite-reason", "class", "onClick"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}